import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';

export interface TopicSearchResult {
  id: string;
  title: string;
  topic_type: string;
  module_title: string;
  batch_id: string;
}

export function useTopicSearch(q: string) {
  return useQuery<TopicSearchResult[]>({
    queryKey: ['topics', 'search', q],
    queryFn: async () => {
      const { data } = await apiClient.get('/api/v1/lms/topics/search', { params: { q } });
      return Array.isArray(data) ? data : [];
    },
    enabled: q.trim().length >= 2,
    staleTime: 0,
  });
}
